import { ReactElement } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

interface Props {
  open: boolean
  onClose: () => void
  /** Run the guided workflow on the file that is already selected (upload step is skipped). */
  onUseCurrent: () => void
  /** Start the guided workflow with an upload as the first step. */
  onUploadNew: () => void
}

/**
 * Shown when the user starts the guided IFC import while a file is already selected: lets them
 * either run the workflow on the current file or upload a new one first.
 */
const GuidedStartDialog = ({ open, onClose, onUseCurrent, onUploadNew }: Props): ReactElement => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Geführten Import starten</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Es ist bereits eine IFC-Datei ausgewählt. Möchten Sie den geführten Import mit der aktuellen
        Datei durchführen oder zuerst eine neue Datei hochladen?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button size="small" onClick={onClose}>
        Abbrechen
      </Button>
      <Button
        size="small"
        variant="outlined"
        onClick={onUploadNew}
        data-cy="guided-start-upload-new"
      >
        Neue Datei
      </Button>
      <Button
        size="small"
        variant="contained"
        onClick={onUseCurrent}
        data-cy="guided-start-use-current"
      >
        Aktuelle Datei
      </Button>
    </DialogActions>
  </Dialog>
)

export default GuidedStartDialog
